'use client';
/**
 * components/auth/Connecte.tsx — les deux gardes d'affichage.
 *
 * Remplacent <SignedIn> / <SignedOut> de Clerk. Même contrat, une nuance qui
 * compte : tant que la session n'est pas connue, NI L'UN NI L'AUTRE ne rend
 * quoi que ce soit. Afficher « Connexion » à quelqu'un qui est connecté, le
 * temps d'un aller-retour, c'est le flash qu'on chassait déjà le 30/07.
 */
import { useCompte } from '@/lib/auth/client';

export function Connecte({ children }: { children: React.ReactNode }) {
  const { isLoaded, isSignedIn } = useCompte();
  if (!isLoaded || !isSignedIn) return null;
  return <>{children}</>;
}

export function Deconnecte({ children }: { children: React.ReactNode }) {
  const { isLoaded, isSignedIn } = useCompte();
  if (!isLoaded || isSignedIn) return null;
  return <>{children}</>;
}
